import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import CampaignStatusDomainService from "../../../Domain/CampaignStatus/CampaignStatus.service";
const CampaignStatusBadge = ({ status, className }) => {
    const color = CampaignStatusDomainService.getColor(status.id);
    return (_jsx("div", { children: _jsx("span", { className: `badge badge-${color} ${className || ""}`, "data-toggle": "tooltip", title: status.description, children: status.name }) }));
};
export default CampaignStatusBadge;
